<template>
  <b-modal
    ref="previewJson"
    v-model="visible"
    hide-footer
    :title="title"
    body-class="p-0"
    centered
  >
    <prism
      class="prism-no-shadow"
      language="json"
    >
      {{ content }}
    </prism>
  </b-modal>
</template>

<script>
import 'prismjs'
import 'prismjs/themes/prism-coy.css'
import 'prismjs/components/prism-json.min'
import Prism from 'vue-prism-component'

export default {
  components: {
    Prism,
  },
  props: {
    codeLanguage: {
      default: 'markup',
      type: String,
    },
    value: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      content: '',
      title: '',
      visible: false,
    }
  },
  watch: {
    visible() {
      if (!this.visible) {
        setTimeout(() => {
          this.closeDialog()
        }, 500)
      }
    },
    value(val) {
      if (val) {
        this.content = this.value.content ? this.value.content : 'No preview'
        this.title = this.value.title ? this.value.title : 'Preview JSON'
        this.visible = !!this.value
      }
    },
  },
  methods: {
    closeDialog() {
      if (!this.visible) {
        this.$emit('input', null)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import 'bootstrap/scss/functions';
@import '~@core/scss/base/bootstrap-extended/variables';
@import 'bootstrap/scss/variables';
@import '~@core/scss/base/components/variables-dark';

.card-code {
  pre[class*='language-'] {
    margin: 0;
    max-height: 350px;
    border-radius: 0.5rem;
  }

  /* width */
  ::-webkit-scrollbar {
    width: 8px;
    height: 8px;
    background: #2d2d2d;
    border-radius: 100%;

    .dark-layout & {
      background-color: $theme-dark-body-bg !important;
    }
  }

  /* Track */
  ::-webkit-scrollbar-track {
    background: transparent;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    border-radius: 0.5rem;
    background: rgba(241, 241, 241, 0.4);
  }

  /* Handle on hover */
  // ::-webkit-scrollbar-thumb:hover {
  // }

  ::-webkit-scrollbar-corner {
    display: none;
  }
}

.code-toggler {
  border-bottom: 1px solid transparent;

  &[aria-expanded='false'] {
    border-bottom-color: $primary;
  }
}
</style>
